import { createReducer, on } from '@ngrx/store';
import { Cart } from '../../core/models';
import { AuthActions } from '../auth/auth.actions';
import { OrdersActions } from '../orders/orders.actions';
import { CartActions } from './cart.actions';

export interface CartState {
  items: Cart;
}

export const initialCartState: CartState = { items: {} };

/** Write `qty` for `id`, or drop the key when qty <= 0. */
function put(items: Cart, id: string, qty: number): Cart {
  const next = { ...items };
  if (qty <= 0) delete next[id];
  else next[id] = qty;
  return next;
}

export const cartReducer = createReducer(
  initialCartState,

  on(CartActions.addToCart, (state, { productId, delta, stock }) => {
    if (stock === 0) return state;
    const prev = state.items[productId] ?? 0;
    const qty = Math.max(0, Math.min(stock, prev + delta));
    return { ...state, items: put(state.items, productId, qty) };
  }),

  on(CartActions.setQty, (state, { productId, raw, stock }) => {
    if (stock === 0) return state;
    const digits = String(raw).replace(/\D/g, '');
    if (digits === '') return { ...state, items: put(state.items, productId, 0) };
    const qty = Math.min(parseInt(digits, 10), stock);
    return { ...state, items: put(state.items, productId, qty) };
  }),

  on(CartActions.removeFromCart, (state, { productId }) => ({
    ...state,
    items: put(state.items, productId, 0),
  })),

  on(CartActions.clearCart, (state) => ({ ...state, items: {} })),

  // A successful order empties the basket (silently — no toast).
  on(OrdersActions.placeOrderSuccess, (state) => ({ ...state, items: {} })),

  on(AuthActions.logout, () => initialCartState),
);
